export const getAuthToken = (): string => {
  const auth = localStorage.getItem('auth');
  if (!auth) return '';
  return JSON.parse(auth).accessToken || '';
};
